import {MDIcons} from '@mintdata-wsp/common/components/icon/MDIcons';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {Input, InputSize, InputStyle} from '@mintdata-wsp/wsp/ui/components/forms/Input';
import {Row} from '@mintdata-wsp/wsp/ui/components/forms/Row';
import * as classnames from 'classnames/bind';
import debounce from 'lodash/debounce';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./DesignsSearch.less');
const cx = classnames.bind(styles);

export enum DesignsSearchFilter
{
    Designs = 'Designs',
    Applications = 'Applications',
    Templates = 'Templates',
}

interface Props
{
}

@observer
export class DesignsSearch extends React.Component<Props, any>
{
    private _onClickFilter = (filter:DesignsSearchFilter) =>
    {
        controllers.ui.mainPage.setDesignsSearchFilter(filter);
    };

    private _renderFilter = (filter:DesignsSearchFilter):JSX.Element =>
    {
        const designsSearchFilter = controllers.ui.mainPage.getDesignsSearchFilter();

        return (
            <Row
                className={cx(styles.filter, {active: designsSearchFilter === filter})}
                onClick={() => this._onClickFilter(filter)}
            >
                {filter}
            </Row>
        );
    };

    private _onChangeSearchString(newValue)
    {
        controllers.ui.mainPage.setDesignsSearchString(newValue);
    }

    private _onChangeSearchStringDebounced = debounce(this._onChangeSearchString, 100);

    render():JSX.Element
    {
        const searchString:string = controllers.ui.mainPage.getDesignsSearchString();

        return (
            <Row className={cx(styles.wrapper)}>

                <Row className={styles.searchWrapper}>
                    <Input
                        placeholder={'Start typing a design or application name...'}
                        icon={MDIcons.common.Search}
                        style={InputStyle.Simple}
                        size={InputSize.Large}
                        className={styles.searchInput}
                        iconClassName={styles.searchIcon}
                        onChange={this._onChangeSearchStringDebounced}
                        initialValue={searchString}
                        isInitiallyFocused={true}
                        isInitiallySelected={true}
                    />
                </Row>

                {/* TODO: wait for templates */}
                {/*<Row className={styles.filters}>*/}
                {/*    {this._renderFilter(DesignsSearchFilter.MyOrganization)}*/}
                {/*    {this._renderFilter(DesignsSearchFilter.Templates)}*/}
                {/*</Row>*/}

            </Row>
        );
    }
}
